import { ref, watchEffect } from 'vue'

type Theme = 'light' | 'dark'

const theme = ref<Theme>(
  (localStorage.getItem('ns-theme') as Theme | null)
  ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
)

watchEffect(() => {
  const root = document.documentElement
  if (theme.value === 'dark') {
    root.classList.add('dark')
    root.style.colorScheme = 'dark'
  } else {
    root.classList.remove('dark')
    root.style.colorScheme = 'light'
  }
  localStorage.setItem('ns-theme', theme.value)
})

export function useTheme() {
  const toggle = () => { theme.value = theme.value === 'dark' ? 'light' : 'dark' }
  const isDark  = () => theme.value === 'dark'
  return { theme, toggle, isDark }
}
